import Card from './Card.vue'

export default {
    'tl-card': Card,
}
